import Table from 'antd/es/table';
import styled, { css } from 'styled-components';
export const SortedTableBase = styled((Table)) `
  --sorted-table-cell-padding-y: ${({ theme }) => theme.spacing.base + theme.spacing.xs / 2}px;
  --sorted-table-cell-padding-x: ${({ theme }) => theme.spacing.base + theme.spacing.xs}px;

  ${({ $compact, theme }) => $compact &&
    css `
      --sorted-table-cell-padding-y: ${theme.spacing.sm}px;
      --sorted-table-cell-padding-x: ${theme.spacing.md}px;
    `}

  .ant-table-body,
  .ant-table-content {
    overflow-x: ${({ $horizontalScroll }) => $horizontalScroll ? 'auto' : 'hidden'} !important;
  }

  .ant-table-sticky-scroll {
    display: none !important;
  }

  .ant-table {
    background: ${({ theme }) => theme.colors.white_1};
    border-radius: 0;
  }

  .ant-table-container {
    border: 1px solid ${({ theme }) => theme.colors.grey_2};
    border-radius: 3px;
    overflow: hidden;
    background: ${({ theme }) => theme.colors.white_1};
    position: relative;
    overscroll-behavior-x: ${({ $naturalHeight }) => $naturalHeight ? 'auto' : 'contain'};
    overscroll-behavior-y: auto;
  }

  .ant-table-header {
    background: ${({ theme }) => theme.colors.purple_2};
    border-radius: 0;
    overflow: hidden;
  }

  .ant-table-header table,
  .ant-table-thead {
    background: ${({ theme }) => theme.colors.purple_2};
    border-radius: 0;
  }

  .ant-table-thead > tr > th {
    background: transparent;
    color: ${({ theme }) => theme.colors.white_1};
    text-transform: uppercase;
    font-size: ${({ theme }) => theme.fonts.overline};
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
    letter-spacing: 0.4px;
    padding: ${({ theme }) => `${theme.spacing.base + theme.spacing.xs / 2}px ${theme.spacing.base + theme.spacing.xs}px`};
    border-bottom: 1px solid ${({ theme }) => theme.colors.purple_1} !important;
    border-right: 1px solid ${({ theme }) => theme.colors.purple_1};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 0 !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-thead > tr > td,
  .ant-table-thead > tr:first-child > th:first-child,
  .ant-table-thead > tr:first-child > th:last-child {
    border-start-start-radius: 0 !important;
    border-start-end-radius: 0 !important;
    border-end-start-radius: 0 !important;
    border-end-end-radius: 0 !important;
  }

  .ant-table-thead > tr > th::before,
  .ant-table-thead > tr > td::before {
    display: none !important;
  }

  .ant-table-thead > tr > th:last-child {
    border-right: none;
  }

  /* A pinned header cell stays put while the rest of the header scrolls under
     it, so it needs the header's own colour: the transparent background above
     would let the columns passing beneath show through it. Body cells already
     paint themselves. */
  .ant-table-thead > tr > th.ant-table-cell-fix-left,
  .ant-table-thead > tr > th.ant-table-cell-fix-right {
    background: ${({ theme }) => theme.colors.purple_2};
  }

  .ant-table-thead > tr > th.ant-table-cell-scrollbar,
  .ant-table-header .ant-table-cell-scrollbar {
    background: ${({ theme }) => theme.colors.purple_2};
    border-bottom: 1px solid ${({ theme }) => theme.colors.purple_1} !important;
    border-right: none;
    border-left: 1px solid ${({ theme }) => theme.colors.purple_1} !important;
    box-shadow: none !important;
  }

  .ant-table-cell-scrollbar {
    background: ${({ theme }) => theme.colors.purple_2} !important;
    border-left: 1px solid ${({ theme }) => theme.colors.purple_1} !important;
    box-shadow: none !important;
  }

  .ant-table-body {
    background: ${({ theme }) => theme.colors.white_1};
  }

  .sorted-table-link,
  .sorted-table-clickable,
  .dashboard-link,
  .dashboard-clickable {
    cursor: pointer;
    text-decoration: none;
  }

  .sorted-table-link:hover,
  .sorted-table-clickable:hover,
  .dashboard-link:hover,
  .dashboard-clickable:hover {
    color: ${({ theme }) => theme.colors.purple_1} !important;
    text-decoration: underline !important;
    text-decoration-thickness: 2px;
    text-underline-offset: 2px;
  }

  .sorted-table-row-clickable > td,
  .sorted-table-row-clickable > .ant-table-cell,
  .dashboard-row-clickable > td,
  .dashboard-row-clickable > .ant-table-cell {
    cursor: pointer;
    transition:
      background 0.15s ease,
      color 0.15s ease;
  }

  .sorted-table-row-clickable:hover > td,
  .sorted-table-row-clickable:hover > td.ant-table-cell,
  .sorted-table-row-clickable:hover > .ant-table-cell,
  .sorted-table-row-clickable > td.ant-table-cell-row-hover,
  .sorted-table-row-clickable > .ant-table-cell-row-hover,
  .dashboard-row-clickable:hover > td,
  .dashboard-row-clickable:hover > td.ant-table-cell,
  .dashboard-row-clickable:hover > .ant-table-cell,
  .dashboard-row-clickable > td.ant-table-cell-row-hover,
  .dashboard-row-clickable > .ant-table-cell-row-hover {
    background: ${({ theme }) => theme.colors.purple_5} !important;
  }

  .sorted-table-row-clickable:hover:not(:has(.sorted-table-clickable:hover)):not(:has(.dashboard-clickable:hover))
    .sorted-table-task-title,
  .sorted-table-row-clickable:hover:not(:has(.sorted-table-clickable:hover)):not(:has(.dashboard-clickable:hover))
    .dashboard-task-title,
  .dashboard-row-clickable:hover:not(:has(.sorted-table-clickable:hover)):not(:has(.dashboard-clickable:hover))
    .sorted-table-task-title,
  .dashboard-row-clickable:hover:not(:has(.sorted-table-clickable:hover)):not(:has(.dashboard-clickable:hover))
    .dashboard-task-title {
    color: ${({ theme }) => theme.colors.purple_1} !important;
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 2px;
  }

  .ant-table-tbody > tr > td,
  .ant-table-tbody > tr > td.ant-table-cell,
  .ant-table-tbody-virtual .ant-table-row > .ant-table-cell {
    padding: var(--sorted-table-cell-padding-y) var(--sorted-table-cell-padding-x);
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4} !important;
    border-right: 1px solid ${({ theme }) => theme.colors.grey_4};
    text-align: left;
    vertical-align: middle !important;
    background: ${({ theme }) => theme.colors.white_1};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ant-table-cell .ant-typography {
    margin: 0;
  }

  .sorted-table-cell-inner,
  .dashboard-cell-inner {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 100%;
    min-width: 0;
  }

  .sorted-table-cell-inner > *,
  .dashboard-cell-inner > * {
    min-width: 0;
  }

  .sorted-table-overflow-tooltip {
    width: 100%;
  }

  .sorted-table-cell-inner-left,
  .dashboard-cell-inner-left {
    justify-content: flex-start;
  }

  .sorted-table-cell-inner-center,
  .dashboard-cell-inner-center {
    justify-content: center;
  }

  .sorted-table-cell-inner-right,
  .dashboard-cell-inner-right {
    justify-content: flex-end;
  }

  .sorted-table-empty-row > .ant-table-cell,
  .sorted-table-empty-row.ant-table-row > .ant-table-cell,
  .dashboard-empty-row > .ant-table-cell,
  .dashboard-empty-row.ant-table-row > .ant-table-cell {
    overflow: visible !important;
    border-right: none !important;
    background: ${({ theme }) => theme.colors.white_1};
  }

  .sorted-table-empty-row > .ant-table-cell:not(:first-child),
  .dashboard-empty-row > .ant-table-cell:not(:first-child) {
    background: transparent !important;
  }

  /* A full-width row is one cell spanning every column, so when the table also
     pins a column that cell is the pinned one -- and antd hangs the pinned
     column's shadow off its right edge, 30px wide and translated clear of it.
     On a normal row that edge is a column boundary; here it is the table's own
     edge, so the strip shades nothing and adds 30px of blank scrollable width
     past the last column. */
  .sorted-table-full-width-row > .ant-table-cell-fix-left-last::after,
  .sorted-table-full-width-row > .ant-table-cell-fix-right-first::before {
    display: none !important;
  }

  .sorted-table-full-width-row > .ant-table-cell,
  .sorted-table-full-width-row.ant-table-row > .ant-table-cell,
  .dashboard-full-width-row > .ant-table-cell,
  .dashboard-full-width-row.ant-table-row > .ant-table-cell {
    cursor: default;
    overflow: visible !important;
    padding-top: ${({ theme }) => theme.spacing.xs}px !important;
    padding-bottom: ${({ theme }) => theme.spacing.xs}px !important;
    border-right: none !important;
    background: ${({ theme }) => theme.colors.beige_2};
  }

  .sorted-table-full-width-row-danger > .ant-table-cell,
  .sorted-table-full-width-row-danger.ant-table-row > .ant-table-cell,
  .dashboard-full-width-row-danger > .ant-table-cell,
  .dashboard-full-width-row-danger.ant-table-row > .ant-table-cell {
    background: ${({ theme }) => theme.colors.red_5};
  }

  .sorted-table-empty-label,
  .dashboard-empty-label {
    display: inline-block;
    white-space: nowrap;
    color: ${({ theme }) => theme.colors.grey_2};
  }

  .ant-table-tbody > tr > td:last-child,
  .ant-table-tbody-virtual .ant-table-row > .ant-table-cell:last-child {
    border-right: none;
  }

  .ant-table-tbody > tr:last-child > td,
  .ant-table-tbody-virtual .ant-table-row:last-child > .ant-table-cell {
    border-bottom: none !important;
  }

  .ant-table-body {
    scrollbar-gutter: stable;
  }
`;
export const SortedTableEditableCellRoot = styled.div `
  width: 100%;
`;
export const SortedTableEditableCellContent = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;
  min-height: ${({ theme }) => theme.spacing.lg}px;
  cursor: pointer;

  svg {
    flex-shrink: 0;
    color: ${({ theme }) => theme.colors.grey_2};
  }
`;
export const SortedTableEditableCellEditor = styled.div `
  width: 100%;
`;
export const SortedTableSorter = styled.span `
  display: inline-flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs / 2}px;
  margin-left: ${({ theme }) => theme.spacing.xs}px;
  line-height: 0;
  color: rgba(0, 0, 0, 1);

  &::before,
  &::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
  }

  &::before {
    border-bottom: 6px solid currentColor;
    opacity: ${({ $active, $direction }) => $active ? ($direction === 'asc' ? 1 : 0.25) : 0.25};
  }

  &::after {
    border-top: 6px solid currentColor;
    opacity: ${({ $active, $direction }) => $active ? ($direction === 'desc' ? 1 : 0.25) : 0.25};
  }
`;
